export const documentType = {
  leadSupportingDocuments: 1,
  userDocuments: 2,
  siteDocuments: 3,
};
